import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import {
  getLatestOpenLiveChats,
  getLatestOpenTopics,
} from '../reduxes/slices/topics/selectors'

export const useIsTopicInLatest = () => {
  const latestGroupChats: any = useSelector(getLatestOpenTopics)
  const latestLiveChats: any = useSelector(getLatestOpenLiveChats)

  return useCallback(
    (id) => {
      const latestTopics = [...latestGroupChats, ...latestLiveChats]
      const latestTopicIds = latestTopics.map((topic: any) => topic.id)
      return latestTopicIds.includes(id)
    },
    [latestGroupChats, latestLiveChats],
  )
}
